import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";

import CommonTable from "../../common/table";
import { createRowCellContentInner, getCellClassNameInner } from "../../common/table";
import { SelectIcon } from "../../common/icons";

import "./styles.less";
import { IconButton } from "@mui/material";
import { useIntl } from "react-intl";

const GroupRoleTable = ({ rows, selectedRole, onExpandClick, handleRowClick, columns: externalColumns }) => {
    const [activeRowId, setActiveRowId] = useState("");
    const intl = useIntl();

    const defaultColumns = useMemo(
        () => [
            {
                id: "expand",
                type: "expand",
            },

            {
                id: "role",
                title: intl.formatMessage({ id: "report-modeling-group-role-table.columns.role" }),
                type: "text",
            },
            {
                id: "systemId",
                title: intl.formatMessage({ id: "report-modeling-group-role-table.columns.system" }),
                type: "text",
            },
            {
                id: "roleType",
                title: intl.formatMessage({ id: "report-modeling-group-role-table.columns.role-type" }),
                type: "text",
            },
            {
                id: "description",
                title: intl.formatMessage({ id: "report-modeling-group-role-table.columns.description" }),
                type: "text",
            },
        ],
        [intl]
    );

    const columns = externalColumns || defaultColumns;

    useEffect(() => {
        if (!selectedRole) {
            setActiveRowId("");
        }
    }, [selectedRole]);
    const getCellValue = (row, column) => {
        switch (column.id) {
            case "roleType":
                return row.isComplex ? intl.formatMessage({ id: "common.group-role-text" }) : intl.formatMessage({ id: "common.single-role-text" });

            default:
                return row[column.id];
        }
    };

    const getCellClassName = (row, column, selected) => {
        let className = getCellClassNameInner(row, column, selected);

        if (row.changed) {
            className += ` group-role-table-cell-changed`;
        }

        if (row.status) {
            className += ` group-role-table-cell-${row.status}`;
        }

        if (row.parentRole) {
            className += ` group-role-table-child-cell`;
        }
        if (row.id === activeRowId) {
            className += ` group-role-table-active-cell`;
        }
        return className;
    };

    const onRowClick = (row) => {
        handleRowClick(row, setActiveRowId);
    };

    const createRowCellContent = (row, column, selected, onSelect, getCellValue) => {
        switch (column.type) {
            case "expand": {
                return (
                    <>
                        {row.isComplex && row.open && (
                            <IconButton
                                onClick={() => {
                                    onExpandClick(row);
                                }}
                            >
                                <SelectIcon />
                            </IconButton>
                        )}

                        {row.isComplex && !row.open && (
                            <IconButton
                                onClick={() => {
                                    onExpandClick(row);
                                }}
                                sx={{ transform: "rotate(270deg)" }}
                            >
                                <SelectIcon />
                            </IconButton>
                        )}
                    </>
                );
            }

            default:
                return createRowCellContentInner(row, column, selected, onSelect, getCellValue);
        }
    };

    return (
        <CommonTable
            className="group-role-table"
            rows={rows}
            columns={columns}
            showPagination={false}
            showFiltersActions={false}
            getCellValue={getCellValue}
            createRowCellContent={createRowCellContent}
            getCellClassName={getCellClassName}
            onRowClick={onRowClick}
            getRowId={(row) => row.localId}
        />
    );
};

GroupRoleTable.propTypes = {
    rows: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            role: PropTypes.string,
            systemId: PropTypes.string,
            isComplex: PropTypes.bool,
            description: PropTypes.string,
        })
    ),
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            title: PropTypes.string,
            type: PropTypes.string,
        })
    ),
    selectedRole: PropTypes.object,
    selectedIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    setSelectedIds: PropTypes.func,
    onExpandClick: PropTypes.func,
    handleRowClick: PropTypes.func,
};

export default GroupRoleTable;
